import React, { useState, useEffect } from "react";
import { MainAdminNewsesTop, MainAdminTablesNews } from "../../components/"
import { axiosReq } from "../../commons/axiosReq";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const MainAdminUploadNewsConfirmation = () => {
    const location = useLocation();
    let navigate = useNavigate();

    const [data, setData] = useState();
    const [search, setSearch] = useState("");
    const [reject, setReject] = useState("");

    const ConfirmArticle = async () => {
        const dataUser = await axiosReq("Admins/ConfirmArticle", "put", {
            ArticleId: location?.state?.id,

        });
        console.log(dataUser)
        if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
            //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
            alert("موفقیت آمیز");
            navigate("/news/" + location?.state?.name)

        }
        else {

        }
    }

    const DenyArticle = async () => {
        const dataUser = await axiosReq("Admins/DenyArticle", "put", {
            ArticleId: location?.state?.id,
            RejectDescription: reject
        });
        console.log(dataUser)
        if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
            //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
            alert("موفقیت آمیز");
            navigate("/mainAdmin/newsPendingConfirmation")

        }
        else {

        }
    }
    return (
        <div className="border-borderGray border-2 rounded-[15px]">
            <div className="flex items-center border-b-2 border-borderGray p-[15px]">
                <p className="font-IRANYekanExtra text-[15px] text-mainColor2">متن خبر</p>
                <p className="text-[#ff0000]">*</p>

            </div>
            <div>
                <div></div>
                <div className="p-[30px] flex justify-between">
                    <button onClick={() => DenyArticle()} className="w-[48%] h-[50px] bg-red shadow-norm-shadow rounded-[5px] flex justify-center items-center ">
                        <p className="font-IRANYekanBold text-[18px] text-white">رد خبر</p>
                    </button>
                    <button onClick={() => ConfirmArticle()} className="w-[48%] h-[50px] bg-mainGreen shadow-norm-shadow rounded-[5px] flex justify-center items-center ">
                        <p className="font-IRANYekanBold text-[18px] text-white">تایید خبر</p>
                    </button>

                </div>
                <div>
                    <p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-1">علت رد خبر را بنویسید</p>
                    <textarea onChange={(e) => setReject(e.target.value)} className="h-[280px] w-full focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal p-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="توضیح دسته بندی" />
                </div>

            </div>
        </div>
    )
}

export default MainAdminUploadNewsConfirmation;